import { Configuration } from '@videoblocks/account-service-client';

export const accountServiceConfig = new Configuration({
    basePath: process.env.ACCOUNT_SERVICE_BASE_PATH ?? 'http://localhost:9087',
});
